import { HStack, Icon, IconButton, Spinner, Stack, StackDivider, Text, Tooltip, Wrap, WrapItem } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { HiCursorClick, HiEye } from 'react-icons/hi'

const iconSize = '0.875em'

const StatWithIcon = ({ icon, children, label, ...props }) => (
  <HStack color="gray.500" alignItems="center" lineHeight="1" {...props}>
    <Tooltip label={label}>
      <span>
        <Icon as={icon} width={iconSize} height={iconSize} />
      </span>
    </Tooltip>
    <Text fontSize="sm">{children ? children.toLocaleString() : 0}</Text>
  </HStack>
)

const LinkStats = ({
  children,
  linkId,
  profileId,
  blockId,
  itemId,
  compact,
  impressions,
  clicks,
  collectionName = 'blocks',
  direction = 'row',
}) => {
  // const isSuperAdmin = useRole('isSuperAdmin')
  // const firestore = useFirestore()
  // const [stats, setStats] = useState([])
  // useEffect(() => {
  //   if (firestore && itemId) {
  //     // const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 3600 * 1000)
  //     const profileRef = doc(firestore, 'profiles', profileId)
  //     const allClicks = collection(profileRef, 'clicks')
  //     const allImpressions = collection(profileRef, 'impressions')

  //     const clicksQuery = query(allClicks, where("itemId", "==", itemId));
  //     const impressionsQuery = query(allImpressions, where("itemId", "==", itemId));
  //     Promise.all([
  //       getDocs(clicksQuery),
  //       getDocs(impressionsQuery),
  //     ]).then(([clicksSnap, impressionsSnap]) => {
  //       setStats([clicksSnap.size, impressionsSnap.size])
  //     }).catch(e => {
  //       console.error(e)
  //     })
  //   }
  // }, [firestore, itemId, profileId])

  return (
    <Stack spacing="2">
      {children}
      <HStack>
        <Stack spacing={direction === 'column' ? 2 : 4} flex="1" px="1" direction={direction}>
          <StatWithIcon label="點擊" icon={HiCursorClick}>{clicks?.items?.[itemId]}</StatWithIcon>
          <StatWithIcon label="曝光" icon={HiEye}>{impressions?.items?.[itemId]}</StatWithIcon>
        </Stack>
        {/* {isSuperAdmin && (
          <Button
            size="xs"
            variant="ghost"
            isExternal
            href={`https://console.firebase.google.com/u/0/project/${firestore?.app.options.projectId}/firestore/data/~2Fprofiles~2F${profileId}~2F${collectionName}~2F${blockId}`}
          >
            開啟資料庫
          </Button>
        )} */}

      </HStack>
    </Stack>
  )
}

export default LinkStats
